import { TileLayer } from '@deck.gl/geo-layers';
import type { BitmapLayerProps } from '@deck.gl/layers';
import { parse } from '@loaders.gl/core';
import { GL } from '@luma.gl/webgl';

import { TILE_CDN } from '../../config';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

// Deck.gl 9 still applies layer parameters via WebGL constants on WebGL devices.
const maleeSlopeBitmapOverrides: Pick<BitmapLayerProps, 'parameters'> = {
  parameters: {
    blendFunc: [
      GL.DST_COLOR,
      GL.ONE_MINUS_SRC_ALPHA,
      GL.ONE,
      GL.ONE_MINUS_SRC_ALPHA,
    ],
    blendEquation: [GL.FUNC_ADD, GL.FUNC_ADD],
  } as BitmapLayerProps['parameters'],
};

function renderMaleeSlopeBitmapSubLayer(
  props: Parameters<typeof renderBitmapTileSubLayer>[0]
) {
  return renderBitmapTileSubLayer(props, maleeSlopeBitmapOverrides);
}

export const dmrZFactor10Layer = () =>
  new TileLayer({
    id: 'dmr-z-factor-10-layer',
    getTileData: async ({ bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const url = `https://ags.cuzk.cz/arcgis2/rest/services/dmr5g/ImageServer/exportImage?f=image&bbox=${west},${south},${east},${north}&adjustAspectRatio=false&bboxSR=4326&imageSR=4326&size=256%2C256&format=jpgpng&mosaicRule=%7B%22ascending%22%3Atrue%2C%22mosaicMethod%22%3A%22esriMosaicNorthwest%22%2C%22mosaicOperation%22%3A%22MT_FIRST%22%7D&renderingRule=%7B%22rasterFunctionArguments%22%3A%7B%22Azimuth%22%3A315%2C%22Altitude%22%3A45%2C%22ZFactor%22%3A10%7D%2C%22rasterFunction%22%3A%22Hillshade%22%2C%22variableName%22%3A%22DEM%22%7D`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 0.7,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export const dmrMaleeSlrm = () =>
  new TileLayer({
    id: 'malee-dmr-slrm-layer',
    data: [
      `${TILE_CDN}/malee/cgi-bin/qgis_mapserv.fcgi.exe?MAP=D:/Basic/Basic.qgz&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=CUZK.DMR5G.RVT.SLRM.Z10&STYLE=default&FORMAT=image/png&TILEMATRIXSET=EPSG:3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}`,
    ],
    maxRequests: 17,
    pickable: true,
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export const dmrMaleeSlope = () =>
  new TileLayer({
    id: 'malee-dmr-slope-layer',
    data: [
      `${TILE_CDN}/malee/cgi-bin/qgis_mapserv.fcgi.exe?MAP=D:/Basic/Basic.qgz&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=CUZK.DMR5G.RVT.Slope.Z5&STYLE=default&FORMAT=image/png&TILEMATRIXSET=EPSG:3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}`,
    ],
    maxRequests: 17,
    pickable: true,
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderMaleeSlopeBitmapSubLayer,
  });

export const dmrMaleeSRSlrm = () =>
  new TileLayer({
    id: 'malee-dmr-sr-slrm-layer',
    data: [
      `${TILE_CDN}/malee/cgi-bin/qgis_mapserv.fcgi.exe?MAP=D:/Basic/Basic.qgz&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=UGKKSR.DMR5G.RVT.SLRM.Z10&STYLE=default&FORMAT=image/jpeg&TILEMATRIXSET=EPSG:3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&dpiMode=7&featureCount=10`,
    ],
    maxRequests: 17,
    pickable: true,
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export const dmrMaleeSRSlope = () =>
  new TileLayer({
    id: 'malee-dmr-sr-slope-layer',
    data: [
      `${TILE_CDN}/malee/cgi-bin/qgis_mapserv.fcgi.exe?MAP=D:/Basic/Basic.qgz&SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=UGKKSR.DMR5G.RVT.Slope.Z5&STYLE=default&FORMAT=image/jpeg&TILEMATRIXSET=EPSG:3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&dpiMode=7&featureCount=10`,
    ],
    maxRequests: 17,
    pickable: true,
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderMaleeSlopeBitmapSubLayer,
  });
